import { render, staticRenderFns } from "./InfoNutrition.vue?vue&type=template&id=78d81f70&scoped=true&"
import script from "./InfoNutrition.vue?vue&type=script&lang=js&"
export * from "./InfoNutrition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d81f70",
  null
  
)

export default component.exports